import { useSearchParams } from "react-router-dom";

import { Wordmark } from "@/components/brand/Wordmark";
import { buttonVariants } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";

export default function LoginPage() {
  const [params] = useSearchParams();
  const error = params.get("error");

  return (
    <main className="flex min-h-screen items-center justify-center bg-op-base px-4">
      <Card className="w-full max-w-sm">
        <CardHeader className="items-center text-center">
          <Wordmark />
        </CardHeader>
        <CardContent className="flex flex-col items-stretch gap-4 pb-8 pt-2">
          {error === "denied" ? (
            <p
              role="alert"
              className="rounded border border-op-border bg-op-elevated px-3 py-2 text-sm text-op-secondary"
            >
              Access denied. This app is for CarryYou staff only.
            </p>
          ) : null}

          <a href="/auth/login" className={buttonVariants({ size: "lg" })}>
            Sign in with Microsoft
          </a>

          <p className="text-center text-xs text-op-muted">
            CarryYou warehouse staff only.
          </p>
        </CardContent>
      </Card>
    </main>
  );
}
